import {useQuery} from '@tanstack/react-query'
import {getEventApi} from '../../../apis/event/getEventApi'

const useQueryEvent = (currentPage: number = 1, active: boolean = false) => {
    const PAGE_SIZE = 10
    const {data, refetch} = useQuery({
        queryFn: async () => {
            const {data, pageInfo} = await getEventApi(PAGE_SIZE, currentPage, active)
            return {data, pageInfo}
        },
    })

    return {data: data?.data, pageInfo: data?.pageInfo, refetch}
}

export default useQueryEvent
